export default __webpack_public_path__ + "static/media/issuer.cdf628a4.svg";